let noUiSlider = require('nouislider/distribute/nouislider');
let functions = require('../../modules/functions');

require('./priceslider.less');

jQuery(function() {
    $('.js-priceslider').each(function() {
        var $this = $(this);

        var $line = $this.find('.priceslider__line');
        var $inputFrom = $this.find('.priceslider__input--from');
        var $inputTo = $this.find('.priceslider__input--to');

        setPriceSlider($line, $inputFrom, $inputTo);

        $inputFrom.add($inputTo).change(function() {
            $line[0].noUiSlider.set([$inputFrom.val(), $inputTo.val()]);
        });
    });
});

function setPriceSlider($line, $inputFrom, $inputTo) {
    noUiSlider.create($line[0], {
        start: [$line.data('curmin'), $line.data('curmax')],
        connect: true,
        margin: $line.data('margin'),
        step: $line.data('step'),
        range: {
            min: $line.data('min'),
            max: $line.data('max')
        }
    });

    $line[0].noUiSlider.on('update', function(values) {
        $inputFrom.val(functions.number_format(values[0], 0, '.', ' '));
        $inputTo.val(functions.number_format(values[1], 0, '.', ' '));
    });
}

exports.setPriceSlider = setPriceSlider;



// WEBPACK FOOTER //
// ./blocks/priceslider/priceslider.js